import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab } from '@mui/material';

// Icons
import { Close } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  marginTop10: {
    marginTop: 10,
  },
  modalCloseButton: {
    float: 'right',
    marginTop: -6,
  },
  modalTitle: {
    minimumHeight: 50,
  },
}));

const DeleteModal = ({ item, handleCloseModal, message, deleteAction, deleteLabel, isDisabled }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleDeleteItem = useCallback(() => {
    deleteAction(item);
    handleCloseModal();
  }, [handleCloseModal, item, deleteAction]);

  if (!item) return null;

  return (
    <Dialog
      open={item}
      maxWidth={'lg'}
      fullWidth={true}
      onClose={handleCloseModal}
      aria-labelledby="max-width-dialog-title"
      aria-describedby="modal-slide-description">
      <DialogTitle>
        <Fab size="small" className={classes.modalCloseButton} key="close" aria-label="Close" onClick={handleCloseModal}>
          <Close className={classes.modalClose} />
        </Fab>
        <h2 className={classes.modalTitle}>{t('delete')}</h2>
        <Divider className={classes.marginTop10} />
      </DialogTitle>
      <DialogContent id="modal-slide-description" className={classes.modalBody}>
        <span
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          disabled={isDisabled}
          onClick={handleDeleteItem}
          color="secondary"
          style={{ color: 'black', borderRadius: 0 }}
          variant="contained">
          {deleteLabel ? deleteLabel : t('button.delete')}
        </Button>
        <Button disabled={isDisabled} onClick={handleCloseModal} color="primary">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteModal;
